import React, { useState, useMemo } from "react";
import { InstagramEmbed } from "react-social-media-embed";
import { instagramUrls } from "./urls";

function App() {
  const itemsPerPage = 18;
  const [currentPage, setCurrentPage] = useState(0);

  const currentPosts = useMemo(() => {
    const startIdx = currentPage * itemsPerPage;
    const endIdx = startIdx + itemsPerPage;
    return instagramUrls.slice(startIdx, endIdx);
  }, [currentPage]);

  const totalPages = Math.ceil(instagramUrls.length / itemsPerPage);

  const handlePrevPage = () => {
    if (currentPage > 0) setCurrentPage(currentPage - 1);
  };
  const handleNextPage = () => {
    if (currentPage < totalPages - 1) setCurrentPage(currentPage + 1);
  };

  return (
      <div className="flex flex-col items-center justify-start min-h-screen bg-obsidian text-marble px-4 py-8 font-sans">
        <header className="text-center">
          <h1 className="text-5xl mb-2 font-gothic text-gold tracking-widest uppercase">
            Apothecary Tattoo
          </h1>
          <p className="text-md">1075 Court St #204, San Luis Obispo, CA 93401</p>
          <p className="text-md mb-2">jstockstell@live.com</p>
          <p className="text-sm mb-6 italic">Email for appointments or questions</p>
          <img
              src={`${process.env.PUBLIC_URL}/new_background_cropped.jpg`}
              alt="Art background"
              className="rounded-xl shadow-2xl w-full max-w-xl object-cover border-4 border-gold mx-auto"
          />
          <p className="text-lg mt-4 font-sans text-bone italic">
            Custom ink. Eternal style.
          </p>
        </header>

        <section className="mt-10 w-full max-w-7xl">
          <h2 className="text-3xl font-semibold text-center text-gold mb-6 font-gothic">
            Recent Instagram Posts
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {currentPosts.map((url, index) => (
                <div
                    key={`${currentPage}-${index}`}
                    className="bg-shadow rounded-lg shadow-lg p-2 border border-shadow"
                >
                  <InstagramEmbed url={url} width={328} captioned />
                </div>
            ))}
          </div>

          <div className="flex justify-center items-center mt-8 gap-4">
            <button
                onClick={handlePrevPage}
                disabled={currentPage === 0}
                className="px-4 py-2 bg-gold text-black rounded-md font-bold disabled:opacity-50"
            >
              Previous
            </button>
            <span className="text-lg font-medium">
            Page {currentPage + 1} of {totalPages}
          </span>
            <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages - 1}
                className="px-4 py-2 bg-gold text-black rounded-md font-bold disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </section>
      </div>
  );
}

export default App;
